export function toBoolean (value:any): boolean {
  return value != null && `${value}` !== 'false';
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
